var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 77,
    viewBox: "0 0 266 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_b_420_20801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.337 61.7492V3.61329C246.356 2.32723 245.491 1.13275 244.072 0.485465C242.653 -0.161822 240.899 -0.161822 239.481 0.485465C238.062 1.13275 237.197 2.32723 237.216 3.61329V89.4972C237.216 90.7733 238.085 91.9526 239.496 92.5907C240.907 93.2288 242.646 93.2288 244.057 92.5907C245.468 91.9526 246.337 90.7733 246.337 89.4972L246.337 61.7492Z",
    fill: "url(#paint0_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.056 9.52792L331.055 95.4279C331.055 96.7041 330.186 97.8834 328.775 98.5214C327.364 99.1595 325.625 99.1595 324.214 98.5214C322.803 97.8834 321.934 96.7041 321.934 95.4279V61.7492H321.935V9.52792C321.916 8.24186 322.781 7.04738 324.2 6.4001C325.619 5.75281 327.372 5.75281 328.791 6.4001C330.21 7.04738 331.075 8.24186 331.056 9.52792Z",
    fill: "url(#paint1_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 22.3218L347.999 82.6368C347.999 83.913 347.13 85.0922 345.719 85.7303C344.308 86.3684 342.569 86.3684 341.158 85.7303C339.747 85.0922 338.877 83.913 338.877 82.6368V61.7492H338.879V22.3218C338.86 21.0357 339.725 19.8412 341.144 19.194C342.562 18.5467 344.316 18.5467 345.735 19.194C347.154 19.8412 348.019 21.0357 348 22.3218Z",
    fill: "url(#paint2_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.112 15.8439C314.131 14.5578 313.266 13.3633 311.847 12.716C310.428 12.0687 308.675 12.0687 307.256 12.716C305.837 13.3633 304.972 14.5578 304.991 15.8439V61.7492H304.99V87.3383C304.99 88.6145 305.859 89.7938 307.27 90.4318C308.681 91.0699 310.42 91.0699 311.831 90.4318C313.242 89.7938 314.111 88.6145 314.111 87.3383L314.112 15.8439Z",
    fill: "url(#paint3_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.168 12.2689L297.168 83.2102C297.168 84.4864 296.298 85.6657 294.887 86.3038C293.476 86.9418 291.737 86.9418 290.326 86.3038C288.915 85.6657 288.046 84.4864 288.046 83.2102V61.7492H288.047V12.2689C288.028 10.9829 288.893 9.7884 290.312 9.14111C291.731 8.49383 293.484 8.49383 294.903 9.14111C296.322 9.7884 297.187 10.9829 297.168 12.2689Z",
    fill: "url(#paint4_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.224 28.9396C280.243 27.6536 279.378 26.4591 277.959 25.8118C276.541 25.1645 274.787 25.1645 273.368 25.8118C271.949 26.4591 271.084 27.6536 271.103 28.9396V61.7492H271.102V74.2432C271.102 75.5194 271.971 76.6987 273.382 77.3368C274.794 77.9749 276.532 77.9749 277.943 77.3368C279.354 76.6987 280.224 75.5194 280.224 74.2432L280.224 28.9396Z",
    fill: "url(#paint5_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.28 37.6578L263.28 86.2598C263.282 87.5367 262.413 88.7173 261.001 89.3563C259.59 89.9953 257.85 89.9953 256.438 89.3563C255.026 88.7173 254.157 87.5367 254.159 86.2598L254.159 37.6578C254.14 36.3718 255.006 35.1773 256.424 34.53C257.843 33.8827 259.597 33.8827 261.015 34.53C262.434 35.1773 263.299 36.3718 263.28 37.6578Z",
    fill: "url(#paint6_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.393 21.8855V61.7492L229.393 84.8511C229.395 86.128 228.527 87.3086 227.115 87.9476C225.703 88.5866 223.963 88.5866 222.551 87.9476C221.14 87.3086 220.271 86.128 220.273 84.8511V62.1685H220.272V21.8855C220.253 20.5994 221.118 19.405 222.537 18.7577C223.956 18.1104 225.709 18.1104 227.128 18.7577C228.547 19.405 229.412 20.5994 229.393 21.8855Z",
    fill: "url(#paint7_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.449 61.7492V44.5753C212.449 43.2989 211.58 42.1196 210.169 41.4815C208.757 40.8434 207.019 40.8434 205.608 41.4815C204.196 42.1196 203.327 43.2989 203.327 44.5753V62.1687H203.329V92.9676C203.329 94.2438 204.198 95.4231 205.61 96.0611C207.021 96.6992 208.759 96.6992 210.17 96.0611C211.582 95.4231 212.451 94.2438 212.451 92.9676V61.7492H212.449Z",
    fill: "url(#paint8_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.505 50.9998L195.505 86.5433H195.507C195.507 87.8195 194.638 88.9987 193.227 89.6368C191.815 90.2749 190.077 90.2749 188.666 89.6368C187.255 88.9987 186.385 87.8195 186.385 86.5433V62.1687H186.383V50.9998C186.383 49.7234 187.252 48.5441 188.663 47.9061C190.074 47.268 191.813 47.268 193.224 47.9061C194.636 48.5441 195.505 49.7234 195.505 50.9998Z",
    fill: "url(#paint9_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.56 61.7492V36.257C178.579 34.9709 177.714 33.7764 176.295 33.1291C174.876 32.4819 173.123 32.4819 171.704 33.1291C170.285 33.7764 169.42 34.9709 169.439 36.257V62.1675H169.441V91.807C169.441 93.0831 170.311 94.2624 171.722 94.9005C173.133 95.5386 174.872 95.5386 176.283 94.9005C177.694 94.2624 178.563 93.0831 178.563 91.807V61.7492H178.56Z",
    fill: "url(#paint10_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.616 9.52792V61.7492H161.619V95.4279C161.619 96.7041 160.75 97.8834 159.339 98.5214C157.928 99.1595 156.189 99.1595 154.778 98.5214C153.367 97.8834 152.498 96.7041 152.498 95.4279V62.1673H152.495V9.52792C152.476 8.24186 153.341 7.04738 154.76 6.4001C156.179 5.75281 157.932 5.75281 159.351 6.4001C160.77 7.04738 161.635 8.24186 161.616 9.52792Z",
    fill: "url(#paint11_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.672 61.7492V15.8439C144.691 14.5578 143.826 13.3633 142.407 12.716C140.989 12.0687 139.235 12.0687 137.816 12.716C136.397 13.3633 135.532 14.5578 135.551 15.8439V62.1682H135.554V87.3383C135.554 88.6145 136.423 89.7938 137.834 90.4318C139.245 91.0699 140.984 91.0699 142.395 90.4318C143.806 89.7938 144.676 88.6145 144.675 87.3383V61.7492H144.672Z",
    fill: "url(#paint12_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.729 12.2689V61.7492H127.732V83.2102C127.735 84.488 126.866 85.6698 125.454 86.3093C124.041 86.949 122.3 86.949 120.888 86.3093C119.475 85.6698 118.607 84.488 118.61 83.2102V62.1678H118.608L118.608 12.2689C118.589 10.9829 119.454 9.7884 120.873 9.14111C122.291 8.49383 124.045 8.49383 125.464 9.14111C126.882 9.7884 127.748 10.9829 127.729 12.2689Z",
    fill: "url(#paint13_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.785 61.7492V28.9392C110.785 27.6628 109.916 26.4835 108.505 25.8454C107.093 25.2073 105.355 25.2073 103.943 25.8454C102.532 26.4835 101.663 27.6628 101.663 28.9392V62.1685H101.666V74.2432C101.663 75.521 102.532 76.7028 103.944 77.3423C105.356 77.982 107.097 77.982 108.51 77.3423C109.922 76.7028 110.791 75.521 110.788 74.2432V61.7492H110.785Z",
    fill: "url(#paint14_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8404 37.6578V61.7492H93.844V86.2598C93.8471 87.5376 92.9785 88.7194 91.5661 89.3589C90.1537 89.9986 88.4127 89.9986 87.0003 89.3589C85.5879 88.7194 84.7192 87.5376 84.7223 86.2598V62.1689H84.7193L84.7194 37.6578C84.7004 36.3718 85.5655 35.1773 86.9843 34.53C88.4031 33.8827 90.1567 33.8827 91.5754 34.53C92.9943 35.1773 93.8593 36.3718 93.8404 37.6578Z",
    fill: "url(#paint15_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8966 61.7492V3.61329C76.9155 2.32723 76.0504 1.13275 74.6316 0.485465C73.2128 -0.161822 71.4593 -0.161822 70.0405 0.485465C68.6217 1.13275 67.7566 2.32723 67.7755 3.61329V62.1678H67.7784V89.4972C67.7753 90.7749 68.644 91.9568 70.0564 92.5962C71.4688 93.2359 73.2098 93.2359 74.6222 92.5962C76.0346 91.9568 76.9032 90.7749 76.9002 89.4972V61.7492H76.8966Z",
    fill: "url(#paint16_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9528 21.8855V61.7492H59.9563V84.8511C59.9594 86.1289 59.0908 87.3107 57.6784 87.9502C56.266 88.5899 54.5249 88.5899 53.1125 87.9502C51.7001 87.3107 50.8315 86.1289 50.8346 84.8511V62.1685H50.8317V21.8855C50.8127 20.5994 51.6778 19.405 53.0966 18.7577C54.5154 18.1104 56.269 18.1104 57.6878 18.7577C59.1066 19.405 59.9717 20.5994 59.9528 21.8855Z",
    fill: "url(#paint17_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.009 61.7492V44.5739C43.0279 43.2878 42.1628 42.0934 40.744 41.4461C39.3252 40.7988 37.5717 40.7988 36.1529 41.4461C34.7341 42.0934 33.869 43.2878 33.8879 44.5739V62.1673H33.8908V92.9676C33.8878 94.2454 34.7564 95.4272 36.1688 96.0667C37.5812 96.7064 39.3222 96.7064 40.7346 96.0667C42.147 95.4272 43.0156 94.2454 43.0125 92.9676V61.7492H43.009Z",
    fill: "url(#paint18_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0652 50.9984V61.7492H26.0663V86.5433H26.0688C26.0718 87.8211 25.2032 89.0029 23.7909 89.6424C22.3784 90.2821 20.6374 90.2821 19.225 89.6424C17.8126 89.0029 16.944 87.8211 16.9471 86.5433V62.1673H16.9441V50.9984C16.9252 49.7124 17.7903 48.5179 19.2091 47.8706C20.6279 47.2233 22.3814 47.2233 23.8002 47.8706C25.219 48.5179 26.0841 49.7124 26.0652 50.9984Z",
    fill: "url(#paint19_linear_420_20801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1214 61.7492V36.257C9.14032 34.9709 8.27524 33.7764 6.85641 33.1291C5.43762 32.4819 3.68408 32.4819 2.26529 33.1291C0.846466 33.7764 -0.0185852 34.9709 0.000335693 36.257L0.000213623 62.1675H0.00317383V91.807C6.10352e-05 93.0847 0.868713 94.2666 2.2811 94.906C3.69351 95.5457 5.43457 95.5457 6.84698 94.906C8.25937 94.2666 9.12796 93.0847 9.12491 91.807V61.7492H9.1214Z",
    fill: "url(#paint20_linear_420_20801)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_420_20801",
    x: -4,
    y: -4,
    width: 356,
    height: 107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_420_20801"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_420_20801",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_420_20801",
    x1: -29.353,
    y1: 73.914,
    x2: 335.981,
    y2: 77.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680896,
    stopColor: "#BAFFDA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955353,
    stopColor: "#00CF5F",
    stopOpacity: 0.8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.246fd4055909a58d8e9d1247f9c6d872.svg";
export { ForwardRef as ReactComponent };